import { render, staticRenderFns } from "./cargo-head.vue?vue&type=template&id=125be1e4&scoped=true"
import script from "./cargo-head.vue?vue&type=script&lang=js"
export * from "./cargo-head.vue?vue&type=script&lang=js"
import style0 from "./cargo-head.vue?vue&type=style&index=0&id=125be1e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125be1e4",
  null
  
)

export default component.exports